import * as React from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import { Button, InputGroup } from "react-bootstrap";
import { Placeholder } from '@aws-amplify/ui-react';
const SmartSelect = ({
    value,
    label,
    onValueChanged,
    minLength = 0,
    maxLength = 0,
    isLoading = false,
    children }) => {

    const errorMessage = () => {
        var error = "";
        if (maxLength !== 0)
            error = (value?.length > maxLength) ? "Should be shorter" : ""
        if (minLength !== 0 && error === "")
            error = (value?.length < minLength) ? "Should be longer" : ""
        return error;
    }
    if (isLoading)
        return (<Placeholder className='my-2' style={{ height: '56px' }}></Placeholder>)
    else
        return (
            <>
                <InputGroup className="mt-2">
                    <FloatingLabel
                        label={label}
                    >
                        <Form.Control
                            list={`${label}-Options`}
                            style={{ maxHeight: '56px' }}
                            isInvalid={errorMessage() !== ""}
                            value={value}
                            onChange={(e) => onValueChanged(e.target.value)}
                            placeholder="Type or select..."
                            className="rounded-end-0"
                        />

                    </FloatingLabel>
                    <Button
                        variant="outline-secondary"
                        className="d-flex align-items-center rounded-end-2"
                        style={{
                            borderLeft: 'none',
                            borderColor: 'lightgray'
                        }}
                        onClick={() => {
                            onValueChanged("")
                        }}>
                        <span className="material-symbols-outlined">
                            close
                        </span>
                    </Button>
                    <datalist id={`${label}-Options`}>
                        {children}
                    </datalist>
                </InputGroup>
                <Form.Text className='error'>
                    {errorMessage()}

                </Form.Text>
            </>

        );
}

export default SmartSelect;
